import { describeMutationError } from "@api/mutationErrors";
import { useWriteErrorStore } from "@api/writeErrorStore";
import { ClinicAuthError } from "@auth/clinicAuthClient";
import { MutationCache, QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  // Reads surface their own failures: `useSuspenseQuery` throws, and the
  // `AsyncBoundary` around each panel renders `PanelError`. Writes can't do
  // that — a mutation rejects long after render, so no error boundary ever sees
  // it — which is what this handler is for.
  //
  // It lives on the cache rather than in `defaultOptions.mutations`, because a
  // per-mutation `onError` *replaces* that default and would silently opt its
  // mutation out of the net. A `MutationCache` handler always runs, so the floor
  // can't be shadowed by a call site (WEB-3319).
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.meta?.handled) return;
      useWriteErrorStore
        .getState()
        .show(describeMutationError(error, mutation.meta?.action));
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (
          error instanceof ClinicAuthError &&
          error.code === "invalid_credentials"
        )
          return false;
        return failureCount < 2;
      },
    },
  },
});
